import gql from 'graphql-tag'

export const FAQ_BY_PRISMIC_ID = gql`
    query faqByPrismicIdQuery($id: String!, $lang: String!) {
        fallbackObject: faq_component(uid: $id, lang: "en-GB") {
            faq {
                question
                answer
            }
        }
        faq: faq_component(uid: $id, lang: $lang) {
            faq {
                question
                answer
            }
        }
    }
`

export const FAQ_RICHTEXT_BY_PRISMIC_ID = gql`
    query faqRichTextByPrismicIdQuery($id: String!, $lang: String!) {
        fallbackObject: faq_component(uid: $id, lang: "en-GB") {
            faq {
                question
                answer
                link_text
                url {
                    ... on _ExternalLink {
                        url
                        target
                    }
                }
            }
        }
        faq: faq_component(uid: $id, lang: $lang) {
            faq {
                question
                answer
                link_text
                url {
                    ... on _ExternalLink {
                        url
                        target
                    }
                }
            }
        }
    }
`

export const EMBED_BOX_BY_PRISMIC_ID = gql`
    query embedBoxByPrismicIdQuery($id: String!, $lang: String!) {
        embed: embeddable_html(uid: $id, lang: $lang) {
            title
            embed
            is_full_width
            _linkType
        }
    }
`

export const TESTIMONIAL_BY_PRISMIC_ID = gql`
    query testimonialByPrismicIdQuery($id: String!, $lang: String!) {
        testimonials: allTestimonial_components(uid: $id, lang: $lang) {
            edges {
                node {
                    _linkType
                    _meta {
                        id
                    }
                    testimonial {
                        avatar
                        name
                        brand_name
                        content
                    }
                }
            }
        }
    }
`

export const USPS_BY_PRISMIC_ID = gql`
    query uspsByPrismicIdQuery($id: String!, $lang: String!) {
        usps: allPlatform_usps(uid: $id, lang: $lang) {
            edges {
                node {
                    _linkType
                    usps {
                        heading: usp_title
                        content: usp_description
                    }
                }
            }
        }
    }
`

export const GET_ALL_LOGO_BOXES = gql`
    query getBrandLogoBox($id: String!, $lang: String!) {
        brandlogobox(uid: $id, lang: $lang) {
            all_boxes_color
            logos_per_row
            title
            _linkType
            brands {
                alternative_logo
                storefront_slug
                storefront_id
                alternative_brand
                highlight_box
                external_link
            }
        }
    }
`

const HOMEPAGE_BANNER_FRAGMENT = gql`
    fragment HOMEPAGE_BANNER on Homepage_banner {
        backgroundImage: background_image
        mobileBackgroundImage: mobile_image_background
        ctaUrl: cta_url
        ctaLabel: cat_label
        ctaBg: button_color
        showBanner: show_banner
        contentText: content_text
        contentTitle: content_title
        contentImage: content_image
    }
`

export const GET_HOMEPAGE_BANNER = gql`
    ${HOMEPAGE_BANNER_FRAGMENT}
    query getHomepageBannerQuery($lang: String!) {
        fallbackObject: homepage_banner(
            uid: "new-homepage-main-banner"
            lang: "en-GB"
        ) {
            ...HOMEPAGE_BANNER
        }
        homepageBanner: homepage_banner(
            uid: "new-homepage-main-banner"
            lang: $lang
        ) {
            ...HOMEPAGE_BANNER
        }
    }
`

